import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import app from "./reducers/app";
import auth from "./reducers/auth";
import modals from "./reducers/modals";
import nonPersist from "./reducers/non-persist";
import openFeedWs from "./reducers/openfeed-ws";
import orderUpdates from "./reducers/order-updates";
import plUpdate from "./reducers/pl-refresh-update";
import stockInfo from "./reducers/stock-info-Reducer";
import commonReducer from "./reducers/common-reducer";
const persistConfig = {
    key: "root",
    storage,
    blacklist: ["modals", "nonPersist", "plUpdate", "commonReducer", "app"],
};
const reducers = combineReducers({
    auth: auth,
    app: app,
    openFeedWs: openFeedWs,
    modals: modals,
    nonPersist: nonPersist,
    plUpdate: plUpdate,
    orderUpdate: orderUpdates,
    stockInfo: stockInfo,
    commonReducer: commonReducer,
});
const persistedReducer = persistReducer(persistConfig, reducers);
const store = configureStore({
    reducer: persistedReducer,
    middleware: [thunk],
});
const persistor = persistStore(store);
export { store, persistor };
